export const TEXT_ROW_ITEM_BLOCK_NAME = 'bb-text-row';
export const TEXT_ROW_ITEM_LABEL = `${TEXT_ROW_ITEM_BLOCK_NAME}--label`;
export const TEXT_ROW_CLASS_TAG = `${TEXT_ROW_ITEM_BLOCK_NAME}--tag`;
export const TEXT_ROW_TOURNAMENT_LOGO = `${TEXT_ROW_ITEM_BLOCK_NAME}--logo`;
